<template>
    <section>
        <div class="py-5 abput_us_section">
            <div class="container ">
                <div class="row">
                    <div class="col-md-6">
                        <div class="col-12 mb-4">

                            <h1 class=" blueFont">
                                نبذة عن قطاع الأحوال المدنية
                            </h1>
                        </div>
                        <div class="col-12">
                            <p>
                                فى إطار العمل الجاد والمستمر بوزارة الداخلية ونحو تنفيذ سياسة الحكومة - بشأن التيسير
                                والتسهيل على المواطنين فى الحصول على الخدمات الحكومية - ومع بدايات العام الجديد 2019 بدء
                                اتخاذ الخطوات اللازمة لتفعيل عمل الحكومة الالكترونية والتى تهدف الى تقديم الخدمات
                                للمواطنين عن بعد من مقر إقامتهم دون الانتقال الى مقر الجهاز الحكومى . وتنفيذا للمنظومة
                                التى تعمل بها وزارة الداخلية بتطوير الأداء الشرطى والاستعانة بأحدث التقنيات العلمية
                                والوسائل الفنية المتاحة فى جميع أدارةات الوزارة لاسيما فى مجال الخدمات ...

                            </p>
                            <a @click="ToAbout" href="#" class="more_link">المزيد <i class="bi bi-arrow-left"></i></a>
                        </div>
                    </div>


                    <div class="col-md-6">
                        <img @click="LightBox" src="@/assets/images/Video.png" alt="" class="img-fluid">
                    </div>
                    <a @click="CloseDiv">
                        <div v-if="play" id="lightbox" class="lightbox">
                            <iframe src="https://www.youtube.com/embed/d6MsNO-kiQc?rel=0&modestbranding=1&autohide=1&mute=1&showinfo=0&controls=1&autoplay=1"
                              width="560" height="315"  
                              frameborder="0" allowfullscreen>
                            </iframe>
                        </div>
                        <div v-else id="lightbox" class="lightbox">

                        </div>
                    </a>

                </div>
            </div>
        </div>
    </section>

</template>

<script >
export default {
    name: 'AboutComp',
    data() {
        return { play: true }
    },
    methods: {
        ToAbout() {
            this.$router.push({ name: 'about' })
        },
        LightBox() {
            this.play = true;
            let element = document.querySelector('.lightbox');
            element.classList.add("active");

        },
        CloseDiv() {
            this.play = false;
            let element = document.querySelector('.lightbox');
            element.classList.remove("active");

        }
    }

}
</script>
<style>
.lightbox {
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    left: 0;
    max-width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: none;
}

.active {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>